module.exports = __webpack_public_path__ + "img/ic_trusted.fe040c86.svg";